import '../../wagons.scss';
import React from 'react';
import Wagon from '../../components/Wagon';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';

const topSeatColumns = [
  [56, 55],
  [52, 51],
  [48, 47],
  [44, 43],
  [40, 39],
  [36, 35],
  [32, 31],
  [28, 27],
  [24, 23],
  [20, 19],
  [16, 15],
  [12, 11],
  [8, 7],
  [4, 3],
];

const seatColumns = [
  [54, 53],
  [50, 49],
  [46, 45],
  [42, 41],
  [38, 37],
  [34, 33],
  [30, 29],
  [26, 25],
  [22, 21],
  [18, 17],
  [14, 13],
  [10, 9],
  [6, 5],
  [2, 1],
];

function GRTOneFour({
  carriageInfo,
  wagonNumber,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const { isDesktop } = useBooking();
  const { trans } = useTranslation();
  return (
    <div className="wagons">
      <div className="title">
        <h1>
          <span className="font-big">{trans('wagon')}</span>
          {' '}
          {wagonNumber}
        </h1>
      </div>
      {isDesktop
        ? (
          <Wagon
            seatColumns={seatColumns}
            topSeatColumns={topSeatColumns}
            seats={carriageInfo?.seats}
            chosenSeats={chosenSeats}
            setChosenSeats={setChosenSeats}
            wagonNumber={wagonNumber}
            reserveSeat={reserveSeat}
            unReserveSeat={unReserveSeat}
            topTablePositions={[1, 6]}
            bottomTablePositions={[0, 6]}
          />
        ) : (
          <div
            style={{
              width: 291 / 2,
              height: 1250 / 2,
            }}
            className="overflow-clip flex justify-center items-center"
          >
            <div className="lg:rotate-0 rotate-90 scale-50">
              <Wagon
                seatColumns={seatColumns}
                topSeatColumns={topSeatColumns}
                seats={carriageInfo?.seats}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                topTablePositions={[1, 6]}
                bottomTablePositions={[0, 6]}
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default GRTOneFour;
